import React from 'react';
import { Link } from 'react-router-dom';
import { Compass, ArrowRight } from 'lucide-react';

/**
 * UnknownVisitorInvite — banner discreto que invita a hacer el Guided Start
 * cuando el usuario aterriza en /buscar sin contexto (ej. viene de Google).
 *
 * Reglas de implementación aplicadas:
 *  · R5 · Discreto, no invasivo, no modal, no bloqueante. Sólo invita.
 *  · Regla del silencio · Si en el futuro se detecta que estorba, se remueve.
 *  · P3 · No interrumpe el flujo del usuario.
 */
export default function UnknownVisitorInvite() {
  return (
    <div
      className="rounded-2xl border border-habita/25 bg-habita-mint/30 px-4 py-3 flex items-center gap-3 flex-wrap"
      data-testid="unknown-visitor-invite"
      role="complementary"
      aria-label="Invitación a personalizar el listado"
    >
      <div className="w-9 h-9 rounded-full bg-white grid place-items-center shrink-0">
        <Compass className="w-4 h-4 text-habita" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-habita-dark leading-tight">
          ¿Quieres recomendaciones personalizadas?
        </p>
        <p className="text-xs text-gray-600 leading-snug mt-0.5">
          Dedica menos de un minuto a contarme qué estás buscando y adaptaré este listado a lo que necesitas.
        </p>
      </div>
      <Link
        to="/advisor/inicio"
        data-testid="unknown-visitor-invite-cta"
        className="inline-flex items-center gap-1.5 h-9 px-4 rounded-full bg-habita text-white text-xs font-semibold hover:opacity-90 whitespace-nowrap"
      >
        Comenzar <ArrowRight className="w-3.5 h-3.5" />
      </Link>
    </div>
  );
}
